// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sWSE","label":"styles_label__3Lktl"};